import React, {
  createContext,
  useContext,
  useMemo
} from 'react';

/** @typedef {'fonema'|'voice'} WhatsappCallsProvider */

/** @type {React.Context<{ provider: WhatsappCallsProvider|null, callUiEvents: object|null }>} */
const WhatsappCallsRuntimeContext = createContext({
  provider: null,
  callUiEvents: null
});

/**
 * @param {Object} props
 * @param {WhatsappCallsProvider} props.provider
 * @param {object|null} [props.callUiEvents]
 */
export const WhatsappCallsRuntimeProvider = ({ provider, callUiEvents = null, children }) => {
  const value = useMemo(
    () => ({ provider, callUiEvents }),
    [provider, callUiEvents]
  );

  return (
    <WhatsappCallsRuntimeContext.Provider value={value}>
      {children}
    </WhatsappCallsRuntimeContext.Provider>
  );
};

export function useWhatsappCallsRuntime() {
  return useContext(WhatsappCallsRuntimeContext);
}

export function useCallUiEvents() {
  const { callUiEvents } = useWhatsappCallsRuntime();
  return callUiEvents;
}

export default WhatsappCallsRuntimeContext;
